var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-card",
        { staticClass: "examineCard" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 9 } }, [
                _c("div", { staticClass: "title-16 mt23" }, [
                  _vm._v("流程设计"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "examineTabs",
                      on: {
                        "tab-click": function ($event) {
                          return _vm.handleClick(_vm.activeName)
                        },
                      },
                      model: {
                        value: _vm.activeName,
                        callback: function ($$v) {
                          _vm.activeName = $$v
                        },
                        expression: "activeName",
                      },
                    },
                    _vm._l(_vm.tabArray, function (item, index) {
                      return _c(
                        "el-tab-pane",
                        { key: index, attrs: { name: item.value } },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c("span", { staticClass: "sp1" }, [
                                _vm._v(_vm._s(item.number)),
                              ]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(item.label))]),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 3 } }, [
                _c(
                  "div",
                  { staticClass: "flex-end" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "mt14",
                        attrs: { size: "small" },
                        on: { click: _vm.submit },
                      },
                      [_vm._v("仅保存")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "mt14",
                        attrs: { type: "primary", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.submit(1)
                          },
                        },
                      },
                      [_vm._v("保存并关闭")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-box" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "basicSetting",
                expression: "activeName === 'basicSetting'",
              },
            ],
            staticClass: "main",
          },
          [
            _c(
              "el-form",
              {
                ref: "elForm",
                staticClass: "mt30",
                attrs: {
                  model: _vm.baseConfig,
                  rules: _vm.rules,
                  "label-width": "110px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "应用实体：", prop: "crud_id" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请选择应用实体",
                          disabled: _vm.$route.query.crud_id ? true : false,
                          size: "small",
                        },
                        on: { change: _vm.crudChange },
                        model: {
                          value: _vm.baseConfig.crud_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.baseConfig, "crud_id", $$v)
                          },
                          expression: "baseConfig.crud_id",
                        },
                      },
                      _vm._l(_vm.options, function (item) {
                        return _c(
                          "el-option",
                          {
                            key: item.id,
                            attrs: { label: item.table_name, value: item.id },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(item.table_name) +
                                  "(" +
                                  _vm._s(item.table_name_en) +
                                  ")"
                              ),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "流程名称：", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入流程名称" },
                      model: {
                        value: _vm.baseConfig.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.baseConfig, "name", $$v)
                        },
                        expression: "baseConfig.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "审批流图标：", prop: "icon" } },
                  [
                    _vm.baseConfig.icon
                      ? _c(
                          "div",
                          {
                            staticClass: "selIcon mr15",
                            style: { backgroundColor: _vm.baseConfig.color },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleIcon($event)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon iconfont",
                              class: _vm.baseConfig.icon,
                              staticStyle: { color: "#fff" },
                            }),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-popover",
                      {
                        ref: "iconPopover",
                        attrs: {
                          placement: "bottom",
                          width: "400",
                          trigger: "click",
                        },
                      },
                      [
                        _vm._l(_vm.iconList, function (i, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "icon-item",
                              on: {
                                click: function ($event) {
                                  return _vm.itemChose(i)
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "icon iconfont",
                                class: i.icon,
                                style: { color: i.color },
                              }),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          { attrs: { slot: "reference" }, slot: "reference" },
                          [_vm._v(_vm._s(_vm.$t("business.changeIcon")))]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "审批说明：", prop: "flowRemark" } },
                  [
                    _c("el-input", {
                      style: { width: "100%" },
                      attrs: {
                        type: "textarea",
                        placeholder: _vm.$t("business.message3"),
                        maxlength: 100,
                        "show-word-limit": "",
                        autosize: { minRows: 4, maxRows: 4 },
                      },
                      model: {
                        value: _vm.baseConfig.info,
                        callback: function ($$v) {
                          _vm.$set(_vm.baseConfig, "info", $$v)
                        },
                        expression: "baseConfig.info",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "processSetting",
                expression: "activeName === 'processSetting'",
              },
            ],
            staticClass: "center",
          },
          [
            _c("processSetting", {
              ref: "processSetting",
              attrs: {
                conf: _vm.mockData.processConfig,
                id: _vm.baseConfig.crud_id,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.activeName === "ruleSetting",
                expression: "activeName === 'ruleSetting'",
              },
            ],
            staticClass: "main",
          },
          [
            _c(
              "el-form",
              {
                ref: "elForm",
                staticClass: "mt30",
                attrs: {
                  model: _vm.ruleConfig,
                  rules: _vm.rules,
                  size: "medium",
                  "label-width": "150px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "异常处理：", prop: "abnormal" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { size: "small" },
                        model: {
                          value: _vm.ruleConfig.abnormal,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleConfig, "abnormal", $$v)
                          },
                          expression: "ruleConfig.abnormal",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v("自动同意"),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v("转交给指定人员处理"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleConfig.abnormal !== 0
                      ? _c("select-member", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            "only-one": true,
                            value: _vm.userList || [],
                          },
                          on: { getSelectList: _vm.getSelectList },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "自动审批：" } },
                  [
                    _c("div", { staticClass: "auto-text" }, [
                      _vm._v(_vm._s(_vm.$t("business.automatic1"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-radio-group",
                      {
                        staticClass: "shu",
                        attrs: { size: "small" },
                        model: {
                          value: _vm.ruleConfig.auto,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleConfig, "auto", $$v)
                          },
                          expression: "ruleConfig.auto",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [
                          _vm._v(_vm._s(_vm.$t("business.automatic2"))),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [
                          _vm._v(_vm._s(_vm.$t("business.automatic3"))),
                        ]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 2 } }, [
                          _vm._v(_vm._s(_vm.$t("business.automatic4"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticClass: "shu", attrs: { label: "修改权限：" } },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.ruleConfig.edit,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleConfig, "edit", $$v)
                          },
                          expression: "ruleConfig.edit",
                        },
                      },
                      [
                        _c("el-checkbox", { attrs: { label: 1 } }, [
                          _vm._v(_vm._s(_vm.$t("business.editAuthority1"))),
                        ]),
                        _vm._v(" "),
                        _c("el-checkbox", { attrs: { label: 2 } }, [
                          _vm._v(_vm._s(_vm.$t("business.editAuthority2"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("business.revokeAuthority") } },
                  [
                    _c("div", { attrs: { slot: "label" }, slot: "label" }, [
                      _vm._v("撤销审批："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.ruleConfig.recall,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleConfig, "recall", $$v)
                          },
                          expression: "ruleConfig.recall",
                        },
                      },
                      [
                        _c("el-checkbox", { attrs: { label: 1 } }, [
                          _vm._v(_vm._s(_vm.$t("business.revokeAuthority1"))),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "tips" }, [
                      _vm._v(_vm._s(_vm.$t("business.revokeAuthority2"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "explain" }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }